import { Box, Table, TableContainer } from '@material-ui/core';

import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import { Body } from '@/components/modules/Notifications/components/Body';
import { getTableColumns } from '@/components/modules/Notifications/constants/getTableColumns';
import {
  AGENT_NOTIFICATIONS,
  BORROWER_NOTIFICATIONS,
  getNotificationsBySecondaryExternalIdType,
} from '@/components/modules/Notifications/constants/utils';
import { NotificationsTableProps } from '@/components/modules/Notifications/types/NotificationsProps';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

export const NotificationsTable = ({ notifications, loan }: NotificationsTableProps) => {
  const { isMobile } = useScreen();
  const tableElementId = 'notifications-table-container';
  const { classes, stickyCellStyle, isScrollable } = useDefaultTable({
    tableElementId,
  });

  const columns = getTableColumns({ isMobile });

  const agentNotifications = getNotificationsBySecondaryExternalIdType(notifications, AGENT_NOTIFICATIONS);
  const borrowerNotifications = getNotificationsBySecondaryExternalIdType(notifications, BORROWER_NOTIFICATIONS);

  return (
    <>
      <SubSectionWrapper title="AGENT_NOTIFICATIONS">
        {agentNotifications.length === 0 ? (
          <PendingDataWarning type={PendingDataType.NO_NOTIFICATIONS} />
        ) : (
          <>
            <TableContainer id={tableElementId}>
              <Table>
                <CustomHeader tableProps={{ classes, stickyCellStyle }} columns={columns} />
                <Body notifications={agentNotifications} loan={loan} tableProps={{ stickyCellStyle }} />
              </Table>
            </TableContainer>
            {isScrollable && (
              <>
                <SliderWarning />
              </>
            )}
          </>
        )}
      </SubSectionWrapper>
      <Box py={2} />
      <SubSectionWrapper title="BORROWER_NOTIFICATIONS">
        {borrowerNotifications.length === 0 ? (
          <PendingDataWarning type={PendingDataType.NO_NOTIFICATIONS} />
        ) : (
          <>
            <TableContainer id={tableElementId}>
              <Table>
                <CustomHeader tableProps={{ classes, stickyCellStyle }} columns={columns} />
                <Body notifications={borrowerNotifications} loan={loan} tableProps={{ stickyCellStyle }} />
              </Table>
            </TableContainer>
            {isScrollable && (
              <>
                <SliderWarning />
              </>
            )}
          </>
        )}
      </SubSectionWrapper>
    </>
  );
};
